import axiosInstance from "../../Utils/axiosInstance";
import {
    accountManager,
    accountManagerHead,
    getLoggedInEmail,
    getLoggedInUserEmail,
    getLoggedInUserGroup,
    getLoggedInUserID,
    isAccountManager,
    isAccountManagerHead,
    isManagement,
    Management,
    sourcingManager,
    sourcingManagerHead
} from "../../Utils/Constant";

interface assignSMData {
    rfqId: number;
    assigningFromId: number;
    assigningToId: number;
    assigningToEmail: string;
    assigningToName: string;
}

export const OrgRepoApi = async () => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getOrganisationDetailsV1?userEmail=${getLoggedInUserEmail()}`
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getOrgFilterMetaFieldsApi = async () => {
    try {
        const response = await axiosInstance.get(
            "api/key_account_management/getOrgFilterMetaFields"
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getCompanyFilterMetaFieldsApi = async () => {
    try {
        const groups = getLoggedInUserGroup(); // e.g. ["North America", "Domestic & Europe"]

        const queryString = groups
            .map((g) => `group=${encodeURIComponent(g)}`)
            .join("&");
        const response = await axiosInstance.get(
            `api/key_account_management/getCompanyFilterMetaFields?${queryString}`
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getCompanyDetailsApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/key_account_management/getAssociatedCompanies?Organisation_Name=" +
                payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getAssociatedRfqsApi = async (
    payload: string,
    isCompany: string
) => {
    try {
        if (isCompany == "Company_Name") {
            const response = await axiosInstance.get(
                "api/key_account_management/getAssociatedRfqs?Company_Name=" +
                    payload
            );
            return response?.data;
        } else {
            const response = await axiosInstance.get(
                "api/key_account_management/getAssociatedRfqs?Organisation_Name=" +
                    payload
            );
            return response?.data;
        }
    } catch (error) {
        return error?.response?.data;
    }
};
export const CompanyApi = async (payload: string) => {
    try {
        if (isManagement()) {
            const response = await axiosInstance.get(
                `api/key_account_management/getCompanyDetailsV1?userEmail=${getLoggedInUserEmail()}`
            );
            return response?.data;
        } else {
            const response = await axiosInstance.get(
                `api/key_account_management/getCompanyDetailsV1?userEmail=${getLoggedInUserEmail()}`
            );
            return response?.data;
        }
    } catch (error) {
        return error?.response?.data;
    }
};

export const getKamProfilePicApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/key_account_management/get_kam_profile_picture?KAMId=" +
                payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getOrgProfileApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/key_account_management/getOrganisationProfile?Org_ID=" +
                payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getCompanyProfileApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/key_account_management/getCompanyProfile?Company_ID=" + payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getCustomerRfqData = async (payload: any) => {
    try {
        const params = new URLSearchParams(payload).toString();
        const response = await axiosInstance.get(
            `api/key_account_management/getCustomerRfqRepositoryNew?${params}`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getCustomerRfqDataV1 = async (payload: any) => {
    try {
        const params = new URLSearchParams(payload).toString();
        const response = await axiosInstance.get(
            `api/key_account_management/getCORFQDetailsV1?${params}`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getCompanyRfqMetaFilterData = async () => {
    try {
        const groups = getLoggedInUserGroup(); // e.g. ["North America", "Domestic & Europe"]

        const queryString = groups
            .map((g) => `group=${encodeURIComponent(g)}`)
            .join("&");
        const response = await axiosInstance.get(
            `api/key_account_management/getCompanyRfqFilterMetaFields?rfqStatus=${accountManagerHead() || accountManager() || Management() ? "KAM" : "stakeholder"}&${queryString}`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getCustomerRfqPartDetails = async (payload: string, status) => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getCustomerRfqPartListing?rfqID=${payload}&status=${status}&kamHead=true`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
// getCustomerRfqPartForPartialQpproval;
export const getCustomerRfqPartForPartialApproval = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getCustomerRfqPartForPartialApproval?rfqID=${payload}`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
export const getCustomerRfqGeneralDetails = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getCustomerRfqDetails?rfqID=${payload}&userEmail=${getLoggedInEmail()}`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface Payload {
    partIds: string[];
    Archived: string;
}

export const updateArchiveAndUnarchiveApi = async (payload: Payload) => {
    try {
        const response = await axiosInstance.post(
            "api/key_account_management/updateArchiveAndUnarchiveParts",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getRfqFeasibilityDetails = async () => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getRfqFeasibilityStakeHolders`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface CreateRfqFeasibilityForm {
    notifierEmail: string;
    approvalStatus: string;
    reason: string;
    companyRfqID: string;
    partIDs?: string[];
}

export const createRfqFeasibleForm = async (
    payload: CreateRfqFeasibilityForm
) => {
    try {
        const response = await axiosInstance.post(
            `api/general/updateStakeHolderRfqApproval`,
            payload
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface CreateRfqFinalApprovalByKamHead {
    finalApprovalStatus: string;
    companyRfq: string;
    reason: string;
}

export const createRfqFinalApprovalByKamHeadForm = async (
    payload: CreateRfqFinalApprovalByKamHead
) => {
    try {
        const response = await axiosInstance.post(
            `api/key_account_management/createRfqFinalApprovalKamHeadForm`,
            payload
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getApprovalStatusDetails = async (payload: any) => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getRfqFeasibilityStakeHolders?rawRfqID=${payload}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
interface requestPayload {
    requestUpdatedBy: string;

    coRfqID: string;
    deptHeadEmail: string;
}
export const updateApprovalRequestAPI = async (payload: requestPayload) => {
    try {
        const response = await axiosInstance.post(
            "api/key_account_management/updateRfqFeasibleRecordByKAMUser",
            payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getDepartment = async () => {
    try {
        const response = await axiosInstance.get(
            `api/general/getMetaDataOfCorfq`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getApproversImg = async (rfqID: string) => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/geAllApproversProfile?rfqID=${rfqID}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getRfqFinalApprovalReportStatusApi = async (payload: string) => {
    try {
        const response = await axiosInstance.get(
            "api/key_account_management/getRfqFeasiblityStatus?rfqID=" + payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
export const getFrfqData = async () => {
    try {
        const response = await axiosInstance.get(
            `api/key_account_management/getCustomerRfqFeasible?userEmail=${getLoggedInEmail()}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
export const getSourcingManagers = async () => {
    try {
        const response = await axiosInstance.get(
            `api/sourcing_management/getSourcingManagers?id=${getLoggedInUserID()}`
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const getAssignSM = async (payload: assignSMData) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/assignTeamMemberForRfq",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};
export const unAssignSM = async (payload) => {
    try {
        const response = await axiosInstance.post(
            "api/sourcing_management/unAssignTeamMemberForRfq",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getCURFQAssignedToMe = async () => {
    try {
        if (isManagement() || isAccountManagerHead() || isAccountManager()) {
            const response = await axiosInstance.get(
                `api/general/getCURFQAssignedToAll`
            );
            return response?.data;
        } else {
            const response = await axiosInstance.get(
                `api/sourcing_management/getCURFQAssignedToMe?loggedInEmailId=${getLoggedInEmail()}`
            );
            return response?.data;
        }
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
interface DeletePartFilePayload {
    ID: string;
    uploadField: string;
}
export const DeleteStepfile = async (payload: DeletePartFilePayload) => {
    try {
        const response = await axiosInstance.post(
            "api/key_account_management/deleteFile",
            payload
        );
        return response?.data;
    } catch (error) {
        return error?.response?.data;
    }
};

export const getProposalsFilterData = async () => {
    try {
        const response = await axiosInstance.get(
            `api/general/getCompanyRFQMetaData`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const uploadProposals = async () => {
    try {
        const response = await axiosInstance.get(`api/general/uploadProposals`);

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

export const deleteProposals = async () => {
    try {
        const response = await axiosInstance.get(
            `api/general/getCompanyRFQMetaData`
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

// Get COPO details by ID

export const viewCoPoDetails = async (payload: any) => {
    try {
        const response = await axiosInstance.get(
            `api/general/viewCoPoData?ID=` + payload?.ID
        );

        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};

interface DroppedCorfqPayload {
    Entity: string;
    Reason: string;
    Department: string;
    Actor: any;
    Company_RFQ: string;
    Notifier: string;
    Name_of_the_Company: string;
    Key_Account_Manager: string;
    Key_Account_Manager_ID: any;
    Total_Order_Value: any;
}

export const saveDroppedCorfq = async (payload: DroppedCorfqPayload) => {
    try {
        const response = await axiosInstance.post(
            `api/key_account_management/saveDroppedCorfq`,
            payload
        );
        return response?.data;
    } catch (error) {
        console.error("Error:", error?.response?.data);
        return error?.response?.data;
    }
};
